import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeftIcon } from 'lucide-react';
const TermsPage: React.FC = () => {
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-6500">
      <Header data-id="element-6501" />
      <main className="flex-grow py-12 px-4 sm:px-6 lg:px-8" data-id="element-6502">
        <div className="max-w-4xl mx-auto" data-id="element-6503">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-6" data-id="element-6504">
            <ArrowLeftIcon className="h-4 w-4 mr-1" data-id="element-6505" />
            Back to Home
          </Link>
          <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8" data-id="element-6506">
            <h1 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-6507">
              Terms of Service
            </h1>
            <div className="prose prose-green max-w-none" data-id="element-6508">
              <p className="text-gray-600 mb-4" data-id="element-6509">
                Last Updated: January 1, 2025
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6510">
                1. Introduction
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6511">
                Welcome to the Edo State E-Services Portal. These Terms of
                Service ("Terms") govern your access to and use of the Edo State
                E-Services Portal, including any content, functionality, and
                services offered on or through the portal.
              </p>
              <p className="text-gray-600 mb-4" data-id="element-6512">
                By using the Edo State E-Services Portal, you accept and agree
                to be bound by these Terms. If you do not agree to these Terms,
                you must not access or use the portal.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6513">
                2. Definitions
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6514">
                "Portal" refers to the Edo State E-Services Portal.
              </p>
              <p className="text-gray-600 mb-4" data-id="element-6515">
                "Services" refers to the various e-government services provided
                through the Portal.
              </p>
              <p className="text-gray-600 mb-4" data-id="element-6516">
                "User", "You", and "Your" refers to the individual or entity
                accessing or using the Portal.
              </p>
              <p className="text-gray-600 mb-4" data-id="element-6517">
                "We", "Us", and "Our" refers to the Edo State Government and its
                authorized representatives.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6518">
                3. Account Registration and Security
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6519">
                To access certain features of the Portal, you may be required to
                register for an account. You agree to provide accurate, current,
                and complete information during the registration process and to
                update such information to keep it accurate, current, and
                complete.
              </p>
              <p className="text-gray-600 mb-4" data-id="element-6520">
                You are responsible for safeguarding your account credentials
                and for any activities or actions under your account. You agree
                to notify us immediately of any unauthorized use of your account
                or any other breach of security.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6521">
                4. User Conduct
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6522">You agree not to:</p>
              <ul className="list-disc pl-6 mb-4 text-gray-600" data-id="element-6523">
                <li data-id="element-6524">
                  Use the Portal in any way that violates any applicable
                  federal, state, local, or international law or regulation
                </li>
                <li data-id="element-6525">
                  Use the Portal to impersonate any person or entity or
                  misrepresent your identity or affiliation with any person or
                  entity
                </li>
                <li data-id="element-6526">
                  Engage in any conduct that restricts or inhibits anyone's use
                  or enjoyment of the Portal
                </li>
                <li data-id="element-6527">
                  Attempt to gain unauthorized access to, interfere with,
                  damage, or disrupt any parts of the Portal
                </li>
                <li data-id="element-6528">
                  Use the Portal in any manner that could disable, overburden,
                  damage, or impair the site
                </li>
                <li data-id="element-6529">
                  Use any robot, spider, or other automatic device, process, or
                  means to access the Portal for any purpose
                </li>
              </ul>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6530">
                5. Payment Terms
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6531">
                Certain Services on the Portal may require payment of fees. All
                fees are stated in Nigerian Naira and are non-refundable unless
                otherwise specified.
              </p>
              <p className="text-gray-600 mb-4" data-id="element-6532">
                You agree to provide accurate and complete payment information
                and authorize us to charge your chosen payment method for the
                Services you select.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6533">
                6. Intellectual Property Rights
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6534">
                The Portal and its entire contents, features, and functionality
                (including but not limited to all information, software, text,
                displays, images, video, and audio, and the design, selection,
                and arrangement thereof) are owned by the Edo State Government,
                its licensors, or other providers of such material and are
                protected by Nigerian and international copyright, trademark,
                patent, trade secret, and other intellectual property or
                proprietary rights laws.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6535">
                7. Limitation of Liability
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6536">
                In no event will the Edo State Government, its affiliates, or
                their licensors, service providers, employees, agents, officers,
                or directors be liable for damages of any kind, under any legal
                theory, arising out of or in connection with your use, or
                inability to use, the Portal, any websites linked to it, any
                content on the Portal or such other websites, including any
                direct, indirect, special, incidental, consequential, or
                punitive damages.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6537">
                8. Changes to the Terms
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6538">
                We may revise and update these Terms from time to time at our
                sole discretion. All changes are effective immediately when we
                post them.
              </p>
              <p className="text-gray-600 mb-4" data-id="element-6539">
                Your continued use of the Portal following the posting of
                revised Terms means that you accept and agree to the changes.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6540">
                9. Governing Law
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6541">
                These Terms shall be governed by and construed in accordance
                with the laws of the Federal Republic of Nigeria, without regard
                to its conflict of law principles.
              </p>
              <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" data-id="element-6542">
                10. Contact Information
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-6543">
                For questions about these Terms, please contact us at:
              </p>
              <p className="text-gray-600 mb-4" data-id="element-6544">
                Edo State ICT Agency
                <br data-id="element-6545" />
                Government House Complex
                <br data-id="element-6546" />
                Benin City, Edo State
                <br data-id="element-6547" />
                Nigeria
                <br data-id="element-6548" />
                Email: support@edostate.gov.ng
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-6549" />
    </div>;
};
export default TermsPage;